<template>
  <div
    :class="$style.root"
    :data-expanded="expanded ? '' : null"
  >
    <ul :class="$style.group">
      <slot name="default" />
    </ul>

    <ul :class="$style.years">
      <slot name="years" />
    </ul>

    <ul :class="$style.countries">
      <slot name="countries" />
    </ul>

    <button
      @click="toggleEditionsNavOpen"
      :class="$style.button"
      tabindex="0"
    >
      {{ !expanded ? $t("shared.all") : $t("shared.hide") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
const mainStore = useMainStore()

const expanded = computed(() => mainStore.editionsNavOpen)

const toggleEditionsNavOpen = () => {
  mainStore.setEditionsNavOpen(!mainStore.editionsNavOpen)
}
</script>

<style module lang="scss">
.root {
  --gap: var(--unit--horizontal);

  padding-left: var(--mask-size);
  margin-left: calc(var(--mask-size) * -1);

  padding-right: var(--mask-size);
  margin-right: calc(var(--mask-size) * -1);

  padding-top: var(--stroke--thin);
  padding-bottom: var(--stroke--thin);

  -ms-overflow-style: none;
  scrollbar-width: none;
}

.root::-webkit-scrollbar {
  display: none;
}

.group {
  composes: reset-list from global;

  columns: 3;

  @media (max-width: $breakpoint-s) {
    columns: 2;
  }
  gap: var(--gap);
}

.root:not([data-expanded]) .group li {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.root:not([data-expanded]) .group li:not([data-within-range]) {
  display: none;
}

.countries,
.years {
  composes: reset-list from global;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  margin-top: var(--lh, 1em);
}

.root:not([data-expanded]) .countries,
.root:not([data-expanded]) .years {
  display: none;
}

.countries li:not(:last-child):after,
.years li:not(:last-child):after {
  content: ', ';
  white-space: pre-wrap;
}

.button {
  composes: reset-button from global;
}

.root[data-expanded] .button {
  margin-top: var(--lh, 1em);
}
</style>
